/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { I18nProvider } from '../../providers/I18nProvider';
import { GeneralSectionController } from './GeneralSectionController';

export function GeneralSection() {
  return (
    <I18nProvider>
      <GeneralSectionController />
    </I18nProvider>
  );
}
